import React, {useContext} from 'react';
import {FormContext} from './MDForm';
import {propsToCSS} from '../css';
import {BASIC_ELEMENT_SCHEMA, Group} from '../layout/Group';
import {merge} from 'lodash';
import {TooltipHint} from './TooltipHint';

const NO_TRACK = v => v;

export function ExpressionWithHint(props) {
  const formContext = useContext(FormContext);


  let missed = false;

  const track = !props.requireAll ? NO_TRACK : v => {
    if (!v) {
      missed = true;
    }
    return v;
  };

  const value = props.value
    .replace(/#{([^}]+)}/g, (_, attr) => track(formContext.getUIValueByAttr(attr))||'')
    .replace(/\${([^}]+)}/g, (_, path) => track(formContext.getValue(path))||'');

  if (missed) {
    return null;
  }
  const hintText = props.hintText;

  return <span tableindex={1} {...propsToCSS(props)} {...props.elementAttr}>{value}
    {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
  </span>;
}

ExpressionWithHint.schema = merge({
  properties: {
    value: {
      type: 'string',
    },
    requireAll: {
      type: 'boolean',
    },
  }
}, BASIC_ELEMENT_SCHEMA);